import React from 'react';
import { graphql, withApollo } from 'react-apollo';
import { useQuery } from '@apollo/react-hooks';

import compose from 'lodash/flowRight';
import Controller from '../transactionImpressions/TransactionImpressionsController';
import GET_TRANSACTION_IMPRESSIONS from '../../../../GraphQl/Queries/GET_TRANSACTION_IMPRESSIONS';
import CURRENT_USER from '../../../../GraphQl/Queries/CURRENT_USER';
import Spinner from '../../../../../platform/shared/designSystem/components/Spinner';

const TransactionImpressionsLoader = ({ children, campaignOrderId, reportName, transactionId }) => {
  const { loading, data } = useQuery(GET_TRANSACTION_IMPRESSIONS, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      campaignOrderId,
      reportName,
      transactionId,
    },
  });

  if (loading) {
    // Compact expanded-row loading pattern — matches the V2 signup
    // impression loader so all three impression-fetch surfaces render
    // the same visual. Expanded rows are tight vertical space; a
    // full-height loading block would push the row taller than the
    // content it's waiting for.
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Spinner size="default" />
      </div>
    );
  }

  let impressions = data && data.getTransactionImpressions;

  return <Controller impressions={impressions}>{children}</Controller>;
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(withApollo(TransactionImpressionsLoader));
